const Sidebar = () => import('./Sidebar')
const Submenu = () => import('./Submenu')

export default function installComponents(Vue) {
  Vue.component('Sidebar', Sidebar)
  Vue.component('Submenu', Submenu)
}
